module.exports = __webpack_public_path__ + "static/N2N6s-af369e4ec794ef28b26a474e0ac001e9.jpg";